'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "realty-type-commercial_svg__a",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "realty-type-commercial_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#realty-type-commercial_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#AD7BCC",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 56)",
    xlinkHref: "#realty-type-commercial_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#realty-type-commercial_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.365 13.694c0 6.67-5.406 12.076-12.076 12.076C5.62 25.77.213 20.364.213 13.694c0-6.67 5.407-12.076 12.076-12.076 6.67 0 12.076 5.406 12.076 12.076",
    fill: "#2C2C2E",
    opacity: 0.2,
    style: {
      mixBlendMode: 'multiply'
    },
    transform: "translate(12 12)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m23.683 21.778 14.73.593 5.08 3.987v.753l-2.16.069V43.11H19.111V27.893l-2.032.065 6.604-6.18Z",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M36.381 22.371v.831l2.54 3.049v1.2h-1.016v-.833l-2.54-3.047v-1.2h1.016Zm-3.556 0v.933l1.016 3.048v1.098h-1.016v-.934l-1.015-3.047v-1.098h1.015Zm-6.603 0v1.2l-2.54 3.047v.832h-1.015v-1.2l2.54-3.048v-.831h1.015Zm3.556 0v1.098l-1.016 3.047v.934h-1.016v-1.098l1.016-3.048v-.933h1.016Zm-12.19-3.048v1.016H12v-1.016h5.587ZM20.42 12c1.206 0 2.296.685 2.873 1.72l.02.034.081-.014c.046-.006.092-.011.139-.015l.14-.005c.703 0 1.373.387 1.799.936l.07.096h3.22v1.016h-3.816l-.142-.277c-.214-.42-.688-.755-1.132-.755-.113 0-.23.021-.356.062l-.094.035-.482.193-.183-.486c-.338-.9-1.192-1.524-2.137-1.524-1.06 0-2.215 1.248-2.283 2.165l-.003.08v.507h-4.61v-1.016h3.656l.019-.077c.338-1.282 1.692-2.607 3.111-2.672l.11-.003Zm-.801 7.323v1.016h-1.016v-1.016h1.016Zm18.512-6.795c.856 0 1.63.373 2.13 1.01l.023.03h.033c.87-.017 1.548.333 1.957 1.093l.046.091H44v1.016h-2.38l-.119-.342c-.229-.663-.624-.896-1.316-.835l-.097.01-.332.04-.168-.29c-.293-.504-.83-.807-1.457-.807-1.013 0-1.64.547-1.688 1.608l-.003.111-.004.505h-3.103v-1.016h2.129l.016-.104c.235-1.302 1.205-2.075 2.535-2.118l.118-.002Zm-7.337 2.224v1.016h-1.016v-1.016h1.016ZM42.143 28.254v14.73h-1v-14.73z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M41.389 43.167H19.167v-1h22.222zM17.389 43.167h-2.667v-1h2.667zM13 43.222h-1v-1h1zM44.111 43.222h-1v-1h1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M23.175 22.371h15.238v-3.556H23.175z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.92 18.308H22.668v4.571H38.92v-4.571Zm-1.015 1.015v2.54H23.683v-2.54h14.222Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.095 27.704v2.91c0 1.257 1.224 2.424 2.54 2.424s2.54-1.167 2.54-2.425c0 1.258 1.224 2.425 2.54 2.425 1.315 0 2.539-1.167 2.539-2.425 0 1.258 1.224 2.425 2.54 2.425s2.54-1.167 2.54-2.425c0 1.258 1.223 2.425 2.539 2.425s2.54-1.167 2.54-2.425c0 1.258 1.224 2.425 2.54 2.425 1.315 0 2.54-1.167 2.54-2.425v-2.909H18.094",
    fill: "#E9EAE6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.584 21.863H23.003L17.587 26v4.499c0 1.597 1.451 3.048 3.048 3.048l.109-.003c.933-.038 1.805-.566 2.353-1.32l.078-.111.005.007c.561.84 1.518 1.427 2.534 1.427l.109-.003c.933-.038 1.805-.566 2.353-1.32l.078-.111.005.007c.562.84 1.519 1.427 2.535 1.427l.108-.003c.933-.038 1.806-.566 2.354-1.32l.077-.111.005.007c.562.84 1.519 1.427 2.535 1.427l.109-.003c.933-.038 1.805-.566 2.353-1.32l.078-.111.005.007c.561.84 1.518 1.427 2.534 1.427 1.597 0 3.048-1.45 3.048-3.048v-4.499l-5.416-4.136Zm-.342 1.016 4.742 3.623v3.996c0 1.036-.996 2.032-2.032 2.032-1.035 0-2.031-.996-2.031-2.032h-1.016c0 1.036-.996 2.032-2.032 2.032s-2.032-.996-2.032-2.032h-1.016c0 1.036-.995 2.032-2.031 2.032s-2.032-.996-2.032-2.032h-1.016c0 1.036-.996 2.032-2.032 2.032-1.035 0-2.031-.996-2.031-2.032h-1.016c0 1.036-.996 2.032-2.032 2.032l-.094-.003c-1.001-.058-1.938-1.024-1.938-2.029v-3.997l4.742-3.622h14.897Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3F3E4B",
    fillRule: "nonzero",
    d: "M44.056 28.056h-24.89v-1h24.89z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.523 42.689c.224-5.848 5.828-7.307 5.828-12.099a6.17 6.17 0 0 0-6.966-6.117c-3.215.404-5.592 3.324-5.352 6.557.328 4.448 5.595 5.994 5.812 11.659h.678",
    fill: "#BFBEC8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.322 23.969c-3.481.437-6.055 3.593-5.796 7.098.122 1.654.766 2.88 2.194 4.623l.825.985.33.397c1.69 2.074 2.38 3.496 2.462 5.636l.02.488h1.654l.02-.488c.084-2.207.815-3.65 2.624-5.833l.837-.996c1.667-2.003 2.367-3.365 2.367-5.289 0-3.96-3.42-7.05-7.388-6.638l-.149.017Zm6.521 6.621c0 1.576-.565 2.727-1.987 4.463l-.98 1.17c-1.498 1.808-2.33 3.186-2.677 4.86l-.016.08-.015-.08c-.346-1.674-1.178-3.052-2.676-4.86l-.836-.994-.28-.343c-1.212-1.506-1.737-2.545-1.837-3.894-.22-2.966 1.966-5.645 4.91-6.015 3.421-.43 6.394 2.212 6.394 5.613Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.143 30.502c0 1.123-.91 2.034-2.032 2.034a2.033 2.033 0 0 1-2.032-2.034c0-1.124.91-2.036 2.032-2.036 1.122 0 2.032.912 2.032 2.036",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.111 27.958a2.542 2.542 0 0 0-2.54 2.544 2.541 2.541 0 0 0 2.54 2.542 2.541 2.541 0 0 0 2.54-2.542 2.542 2.542 0 0 0-2.54-2.544Zm0 1.016c.841 0 1.524.684 1.524 1.528 0 .843-.683 1.526-1.524 1.526a1.526 1.526 0 0 1-1.524-1.526c0-.844.683-1.528 1.524-1.528Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M33.841 42.689h5.08v-7.112h-5.08z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M39.429 35.07h-6.096v8.126h6.096V35.07Zm-1.016 1.015v6.096h-4.064v-6.096h4.064Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M25.714 40.149h6.096v-4.572h-6.096z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.317 35.07h-7.11v5.587h7.11v-5.588Zm-1.015 1.015v3.556h-5.08v-3.556h5.08Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }))));
});
var RealtyTypeCommercial = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyTypeCommercial = RealtyTypeCommercial;